import { atom } from 'recoil';

const composeAtomKey = (name: string) => `AdminPortalQueue_${name}`;

export const activeTabAtom = atom<number>({
  key: composeAtomKey('activeTab'),
  default: 0
});
